export default __webpack_public_path__ + "static/media/templates.a0bfbc8f.svg";